module.exports = __webpack_public_path__ + "static/inspect-mode-feature-news-3fc6458f289724ff4a3bb714204406d2.webm";